import DefaultLayout from '../../components/DefaultLayout';
import { useIntl } from 'react-intl';
import { StyledCartPage } from './style';
import { useCartState } from 'public/context/CartContext';
import { useEffect, useState } from 'react';
import CartStep from 'enums/cart-step';
import { Icon } from 'ui';
import Cart from 'public/components/DefaultLayout/Cart';
import ProcessPurchase from 'public/components/DefaultLayout/ProcessPurchase';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { StyledAntdCartSteps } from 'ui/Steps/style';
import { StepProps } from 'antd';
import { Divider } from 'antd';

type BackButton = {
  text: string;
  onClick: () => void;
};

export const CartPage = () => {
  const intl = useIntl();
  const { farmProducts, priceTotal } = useCartState();
  const [current, setCurrent] = useState<CartStep>(CartStep.CART);
  const [pageTitle, setPageTitle] = useState<string>('');
  const [backButton, setBackButton] = useState<BackButton>({
    text: intl.formatMessage({ id: 'general.back_to_catalog' }),
    onClick: () => navigate('/products/all'),
  });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    switch (current) {
      case CartStep.CART:
        setPageTitle(intl.formatMessage({ id: 'cart.your_cart_title' }));
        setBackButton({
          text: intl.formatMessage({ id: 'general.back_to_catalog' }),
          onClick: () => navigate('/products/all'),
        });
        break;
      case CartStep.PROCESS_ORDER:
        setPageTitle(intl.formatMessage({ id: 'cart.process_purchase' }));
        setBackButton({
          text: intl.formatMessage({ id: 'general.back_to_cart' }),
          onClick: () => setCurrent(CartStep.CART),
        });
        break;
      case CartStep.RECEIVE_ORDER:
        setPageTitle(intl.formatMessage({ id: 'cart.your_order_received_title' }));
        setBackButton({
          text: intl.formatMessage({ id: 'general.continue_shopping' }),
          onClick: () => navigate('/products/all'),
        });
        break;
    }
  }, [current, intl]);

  useEffect(() => {
    const tab = searchParams.get('tab');
    const step = searchParams.get('PROCESS_ORDER');

    if (tab) {
      const numericTab = parseInt(tab, 10);
      setCurrent(numericTab as CartStep);
    }

    if (step) {
      setCurrent(CartStep.PROCESS_ORDER);
    }
  }, [searchParams]);

  const baseSteps: StepProps[] = [
    {
      style: { display: 'flex', justifyContent: 'flex-start' },
      title: intl.formatMessage({ id: 'general.basket' }),
    },
    {
      style: { display: 'flex', justifyContent: 'center' },
      title: intl.formatMessage({ id: 'general.process_your_purchase' }),
    },
    {
      style: { display: 'flex', justifyContent: 'flex-end' },
      title: intl.formatMessage({ id: 'general.order_receipt' }),
    },
  ];

  const stepsItems = baseSteps.map((step, index) => {
    const item: StepProps = { ...step };

    if (index === current) {
      item.status = 'process';
    } else {
      item.status = 'wait';
    }

    return item;
  });

  const steps = (
    <StyledAntdCartSteps
      type="navigation"
      current={current}
      items={stepsItems}
    />
  );

  return (
    <DefaultLayout.PageLayout>
      <DefaultLayout.PageContent>
        <StyledCartPage>
          <div
            className="back-button"
            onClick={backButton.onClick}
          >
            <Icon name={'arrow-left'} type={'any'} />
            <span>{backButton.text}</span>
          </div>
          <div className="container">
            <div className={'cart-page-title'}>
              <h1>{pageTitle}</h1>
            </div>
            {steps}
            <Divider />
            {current === CartStep.CART && (
              <Cart
                priceTotal={priceTotal}
                farmProducts={farmProducts}
                setCurrent={setCurrent}
                current={current}
                isView={false}
              />
            )}
            {current === CartStep.PROCESS_ORDER && (
              <ProcessPurchase
                priceTotal={priceTotal}
                setCurrent={setCurrent}
                farmProducts={farmProducts}
                current={current}
                isView={false}
              />
            )}
            {current === CartStep.RECEIVE_ORDER && (
              <Cart
                priceTotal={priceTotal}
                farmProducts={farmProducts}
                setCurrent={setCurrent}
                current={current}
                isView={true}
              />
            )}
          </div>
        </StyledCartPage>
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};
